import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import ToolSafetyDisclaimer from '../components/tools/ToolSafetyDisclaimer';
import ToolEducationalNote from '../components/tools/ToolEducationalNote';
import BusbarSizingCalculator from '../components/tools/BusbarSizingCalculator';

const BusbarSizingCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="busbar-sizing-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="HV Busbar Sizing Calculator"
        description="Check or size a rectangular copper or aluminium busbar for EV and HV power electronics — temperature rise, peak and duty-cycle heating, short-circuit withstand, skin effect, loss and voltage drop."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="busbar-sizing-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <BusbarSizingCalculator />
          <ToolSafetyDisclaimer
            standards="the CDA Publication 22 heat-balance method, the IEC 60949 adiabatic short-circuit equation and IEC 61439-1 temperature-rise limits, cross-checked against DIN 43671 / DIN 43670"
            className="mt-10 text-[11px]"
            showTerms={false}
          />
          <ToolEducationalNote scope="joints and terminals, nearby heat sources, enclosure airflow, mounting, plating quality, current harmonics and the real fault level all change how hot a busbar runs" />
          <ToolGuideCta guidePath="/tools/busbar-sizing-calculator/guide" toolName="HV Busbar Sizing Calculator" />
        </div>
      </section>
    </div>
  );
};

export default BusbarSizingCalculatorPage;
